import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "DOWNLOAD_DOCUMENT_" }
);

export interface DownloadDocumentState extends IState {
  data: Record<string, any> | null;
}

const INITIAL_STATE: DownloadDocumentState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: DownloadDocumentState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: DownloadDocumentState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: DownloadDocumentState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const downloadDocument = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DownloadDocumentTypes = Types;
export const DownloadDocumentActions = Creators;
